import { render, staticRenderFns } from "./questionnaire-result.vue?vue&type=template&id=21338fa8&scoped=true&"
import script from "./questionnaire-result.vue?vue&type=script&lang=js&"
export * from "./questionnaire-result.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire-result.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./questionnaire-result.vue?vue&type=style&index=1&id=21338fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21338fa8",
  null
  
)

export default component.exports